import { Component, Input, Output, OnInit, EventEmitter } from '@angular/core';
import { Router } from '@angular/router';
import { PAP } from 'src/app/pap-creation/pap-dto/pap-dto';

@Component({
  selector: 'app-pap-body',
  templateUrl: 'pap-body.component.html',
  styleUrls: ['./pap-body.component.less', '../../shared/common.less'],
})

export class PapBodyComponent implements OnInit {
  @Input() papValues: PAP;
  @Output() papValuesChange = new EventEmitter<PAP>();
  @Output() numberOfCollegesChanges = new EventEmitter<number>();
  @Output() toCerfa = new EventEmitter();

  needPap: boolean = true;

  constructor(
    private router: Router,
  ) {}

  onVenueChanges() {
    if (this.papValues.application.mailOption === false) {
      this.papValues.application.address = this.papValues.venue.address;
      this.papValues.application.zip = this.papValues.venue.zipcode;
      this.papValues.application.city = this.papValues.venue.city;
    }

    this.papValuesChange.emit(this.papValues);
  }

  onHeadcountChange(newHeadcount: any) {
    this.papValues.headcount = { ...newHeadcount };
    this.papValuesChange.emit(this.papValues);
  }

  onPapValuesChange() {
    this.papValuesChange.emit(this.papValues);
  }

  onNumberOfCollegesChanges() {
    this.numberOfCollegesChanges.emit(this.papValues.headcount.numberOfColleges);
  }

  goToCerfa() {
    this.toCerfa.emit();
  }

  ngOnInit(): void {
  }
}
